"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.HELP_TEXT_WIDTH = void 0;
exports.HELP_TEXT_WIDTH = '300px';
//# sourceMappingURL=constants.js.map